import { render, staticRenderFns } from "./PondSetting.vue?vue&type=template&id=ea68d98e&"
import script from "./PondSetting.vue?vue&type=script&lang=js&"
export * from "./PondSetting.vue?vue&type=script&lang=js&"
import style0 from "./PondSetting.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports